import styled, { css } from 'styled-components';

export const Container = styled.div`
  padding-right: 44px; // espaço para o ícone de visibilidade
  display: ${props => (props.visible ? 'flex' : 'none')};
  align-items: center;
  width: 100%;
  
  padding: 16px 12px;
  margin-bottom: 16px;
  border-radius: 12px;
  border: 2px solid #e0e0e0;
  background: #ffffff;
  color: #666666;
  position: relative;
  font-size: 16px;
  
  transition: all 0.2s ease-in-out;

  .visibility-toggle {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
    margin: 0;
    color: ${props => props.color || '#01579b'};
  }

  ${props =>
    props.isErrored &&
    css`
      border-color: #e53935;
      color: #e53935;
    `}
  ${props =>
    props.isFocused &&
    css`
      color: ${props.color || '#01579b'};
      border-color: ${props.color || '#01579b'};
      box-shadow: 0 0 0 3px
        ${props.color ? `${props.color}1A` : 'rgba(1, 87, 155, 0.1)'};
    `}

  ${props =>
    props.isFilled &&
    css`
      border-color: #4caf50;
      color: #666666;
    `}

  svg:not(.visibility-toggle) {
    margin-right: 12px;
    flex-shrink: 0;
  }

  input {
    flex: 1;
    background: transparent;
    border: 0;
    font-size: 16px;
    color: #333333;
    outline: none;
    
    &::placeholder {
      color: #999999;
    }
    
    /* Remove estilo de autocomplete do Chrome */
    &:-webkit-autofill,
    &:-webkit-autofill:hover,
    &:-webkit-autofill:focus {
      -webkit-box-shadow: 0 0 0 1000px #ffffff inset;
      -webkit-text-fill-color: #333333;
    }
  }

  label {
    position: absolute;
    top: -8px;
    left: 12px;
    background: #ffffff;
    padding: 0 4px;
    font-size: 12px;
    color: #666666;
    font-weight: 500;
  }
`;

export const Error = styled.div`
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);

  ${props =>
    props.isFocused &&
    css`
      display: none;
    `}

  ${props =>
    props.isFilled &&
    css`
      display: none;
    `}
`;
